const baseURL= 'https://marcalapaz.com/admin/';
//const baseURL= 'http://192.168.1.8/radioCiudad/api-marca/';

export default baseURL;